import { render, staticRenderFns } from "./BaseLayoutWithoutLogo.vue?vue&type=template&id=29464185&scoped=true"
import script from "./BaseLayoutWithoutLogo.vue?vue&type=script&lang=js"
export * from "./BaseLayoutWithoutLogo.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutWithoutLogo.vue?vue&type=style&index=0&id=29464185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29464185",
  null
  
)

export default component.exports